import { IListItem } from '../ilist-item';

export interface ISmartList<T = IListItem> {
    title: string;
    items: T[];
}
